import PropTypes from "prop-types";
import React from "react";
const RCEHelpersPropTypes = {
  rce: PropTypes.shape({
    isViewMode: PropTypes.bool.isRequired,
    setInPluginEditingMode: PropTypes.func,
    helpers: PropTypes.shape({
      handleFileUpload: PropTypes.func
    }),
    getSiteMembers: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired,
  layout: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
const RCEHelpersContext = React.createContext({});
const withRCEHelpers = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(RCEHelpersContext.Consumer, null, ({ layout, design, t, ...rest }) => /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, rce: rest, t, layout, design }));
};
export {
  RCEHelpersContext,
  RCEHelpersPropTypes,
  withRCEHelpers
};
//# sourceMappingURL=index.js.map
